import React, { createContext, useContext, useEffect, useState } from "react";
import { getContent } from "../i18n";

const SiteContext = createContext(null);

export const ACCENTS = [
  { id: "gold", value: "#B08D4F", name: "Gold" },
  { id: "copper", value: "#A9683B", name: "Copper" },
  { id: "sea", value: "#3E6B78", name: "Sea" },
  { id: "moss", value: "#5E7047", name: "Moss" },
  { id: "wine", value: "#8B3A46", name: "Wine" },
];

const LS = {
  mode: "hh_mode",
  accent: "hh_accent",
  lang: "hh_lang",
};

export function SiteProvider({ children }) {
  const [mode, setMode] = useState("dark"); // 'dark' | 'light'
  const [accent, setAccent] = useState(ACCENTS[0].value);
  const [lang, setLang] = useState("en");

  // hydrate from storage (auto-detect language on first visit)
  useEffect(() => {
    try {
      const m = localStorage.getItem(LS.mode);
      const a = localStorage.getItem(LS.accent);
      const l = localStorage.getItem(LS.lang);
      if (m) setMode(m);
      if (a) setAccent(a);
      if (l) {
        setLang(l);
      } else {
        const supported = ["en", "de", "fr", "es", "ru", "zh", "ko", "ja"];
        const nav = (navigator.language || "en").toLowerCase().slice(0, 2);
        if (supported.includes(nav)) setLang(nav);
      }
    } catch (e) {
      /* ignore */
    }
  }, []);

  // apply theme to <html>
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode);
    localStorage.setItem(LS.mode, mode);
  }, [mode]);

  useEffect(() => {
    document.documentElement.style.setProperty("--c-accent", accent);
    localStorage.setItem(LS.accent, accent);
  }, [accent]);

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem(LS.lang, lang);
  }, [lang]);

  const toggleMode = () => setMode((m) => (m === "dark" ? "light" : "dark"));

  const c = getContent(lang);

  return (
    <SiteContext.Provider
      value={{ mode, setMode, toggleMode, accent, setAccent, lang, setLang, c }}
    >
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used within SiteProvider");
  return ctx;
}
